import { Component, OnInit, OnDestroy, Input, HostListener } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CartService } from '../../services/cart.service';
import { restaurants, menuItems, Restaurant, MenuItem } from '../../data/mock';
import { Product } from '../../Model/product';
import { FileServiceService } from '../../services/file-service.service';
import { MatrixDto } from '../../Model/matrix-dto';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { LocalStorageService } from '../../services/local-storage.service';
import { WebOrderMinimumDateTimeSetup } from '../../Model/web-order-minimum-date-time-setup';
import moment from 'moment';
import { ProductService } from '../../services/product.service';
import { WebOrderStockDetailsDto } from '../../Model/web-order-stock-details-dto';
import { ToastService } from '../../services/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonExternalModule } from '../../common/common-external-module';

@Component({
  selector: 'app-restaurant',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent, FooterComponent],
  templateUrl: './restaurant.component.html',
  styleUrl: './restaurant.component.css',
})

export class RestaurantComponent implements OnInit, OnDestroy {
  @Input() aggregatorSetup: any;
  searchQuery = '';
  filterType: 'all' | 'veg' | 'nonveg' | null = 'all';
  cartCount = 0;
  currentUrl: string;
  selectedSubGroup: string | null = null;
  subGroups: string[] = [];
  storeLatitudeMap: number | null = null;
  storeLongitudeMap: number | null = null;

  restaurant: Restaurant | undefined;
  items: Product[] = [];
  allProductList: Product[] = [];
  matrixList: MatrixDto[] = [];
  webOrderMinimumDateTimeList: WebOrderMinimumDateTimeSetup = new WebOrderMinimumDateTimeSetup();
  timeSlot2: string[][] = [];
  timeSlotAvl: string[] = [];
  productList: Product[] = new Array(1200);
  timestamp = Date.now();

  //Subscription
  private cartSubscription!: Subscription;
  private webOrderBestSellersSubcription: Subscription;
  private checkAllowStockSubscription: Subscription;
  private getAggregatorSetupSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cartService: CartService,
    private fileService: FileServiceService,
    private apiFactory: ApiFactoryEndPoints,
    private localStorage: LocalStorageService,
    public productService: ProductService,
    private toastrService: ToastService
  ) { }

  ngOnInit() {
    this.isDesktop = window.innerWidth >= 768;
    this.currentUrl = window.location.host.replace(':', '');
    this.matrixList = this.fileService.getFileData("matrixList");
    this.matrixList.forEach(m => {
      restaurants.forEach(r => {
        if (m.productMatrixName == r.name) {
          r.id = m.refNo;
        }
      })
    })
    this.allProductList = this.fileService.getFileData("allProductList");
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.restaurant = restaurants.find(r => r.id === id);
    this.productList = this.allProductList;

    // this.items = menuItems[id] || menuItems[1] || [];
    this.items = this.allProductList.filter(e =>
      e.productSubGroup?.productGroup?.productMatrix?.refNo == id
    );

    this.subGroups = Array.from(
      new Set(
        this.items
          .map(e => e.productSubGroup?.productSubGroupName)
          .filter(name => !!name)
      )
    );

    this.getWebOrderBestProductSetUpList();
    this.setCurrentLocationStore();
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }

    if (this.getAggregatorSetupSubscription) {
      this.getAggregatorSetupSubscription.unsubscribe();
    }
  }

  private setCurrentLocationStore(): void {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Location permission granted, get coordinates
          this.storeLatitudeMap = position.coords.latitude;
          this.storeLongitudeMap = position.coords.longitude;
          console.log('Latitude:', this.storeLatitudeMap, 'Longitude:', this.storeLongitudeMap);

          // Call API with the fetched location
          this.getAggregatorSetup();
        },
        (error) => {
          // Handle errors
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.toastrService.showErrorToast('Location permission denied. Please allow location access in your browser settings.');
              break;
            case error.POSITION_UNAVAILABLE:
              this.toastrService.showErrorToast('Location information is unavailable. Please try again later.');
              break;
            case error.TIMEOUT:
              this.toastrService.showErrorToast('The request to get user location timed out. Please try again.');
              break;
            default:
              this.toastrService.showErrorToast('An unknown error occurred. Please try again.');
              break;
          }

          // Call API with null latitude & longitude (Location disabled case)
          this.storeLatitudeMap = null;
          this.storeLongitudeMap = null;
          this.getAggregatorSetup();
        },
        {
          enableHighAccuracy: true,
          timeout: 30000,
          maximumAge: 0
        }
      );
    } else {
      // If browser does not support geolocation
      this.toastrService.showErrorToast('Geolocation is not supported by your browser.');

      // Call API with null values
      this.storeLatitudeMap = null;
      this.storeLongitudeMap = null;
      this.getAggregatorSetup();
    }
  }

  getAggregatorSetup() {
    this.getAggregatorSetupSubscription = this.productService.getAggregatorSetup(this.apiFactory.getAggregatorSetupByUrl,
      this.currentUrl, this.storeLatitudeMap != null ? this.storeLatitudeMap.toString() : null, this.storeLongitudeMap != null ? this.storeLongitudeMap.toString() : null)
      .subscribe(data => {
        console.log(data);
        this.aggregatorSetup = data;
      });
  }

  getWebOrderBestProductSetUpList() {
    this.webOrderBestSellersSubcription = this.cartService
      .getWebOrderBestProductSetup(
        this.apiFactory.getBestProducts,
        this.currentUrl
      )
      .subscribe((data) => {
        this.allProductList.forEach(e => {
          data.forEach(d => {
            if (e.product_Code == d.product_Code) {
              e.bestseller = true;
            }
          })
        })
      });
  }

  // get filteredItems(): Product[] {
  //   return this.items.filter(item => {
  //     const matchesSearch = item.product_Name.toLowerCase().includes(this.searchQuery.toLowerCase());
  //     const matchesFilter =
  //       this.filterType === 'all' ||
  //       (this.filterType === 'veg' && item.food_Type == "Veg") ||
  //       (this.filterType === 'nonveg' && item.food_Type == "Non-Veg");

  //     return matchesSearch && matchesFilter;
  //   });
  // }

  async addToCart(product: Product) {
    this.toastrService.showWarningToast('We’re working on this');
    return;
    const locId = JSON.parse(this.localStorage.getItem('location_code'));
    let selectedProduct = product;

    if (!locId) {
      await this.getProductDeliveryTimeAndStockDetails();

      const updatedProduct = this.productList.find(
        p => p.product_Code === product.product_Code
      );
      if (updatedProduct) {
        selectedProduct = updatedProduct;
      }
    }
    // Apply delivery logic only once
    this.setDelivery(selectedProduct);
  }

  getProductDeliveryTimeAndStockDetails(): Promise<void> {
    return new Promise((resolve, reject) => {
      const deliveryType = JSON.parse(this.localStorage.getItem("delivery_type")) ?? 'delivery';
      // const apiUrl = deliveryType === 'storePickup' ? this.apiFactory.getStoreMinimumDateTimeDetails : this.apiFactory.getWebOrderMinimumDateTimeDetails;
      const locId = JSON.parse(this.localStorage.getItem('location_code'));
      const minLocId = deliveryType === 'storePickup' ? locId : null;

      this.cartService.getMinimumDateTimeDetails(this.apiFactory.getWebOrderMinimumDateTimeDetails, this.currentUrl, minLocId).subscribe((data) => {
        if (data) {
          // this.webOrderMinimumDateTimeList.deliveryTime = deliveryType === 'storePickup' ? data?.minOrderTime : data.deliveryTime;
          // this.webOrderMinimumDateTimeList.maxDeliveryTime = deliveryType === 'storePickup' ? data?.maxOrderTime : data.maxDeliveryTime;
          this.webOrderMinimumDateTimeList.deliveryTime = data.deliveryTime;
          this.webOrderMinimumDateTimeList.maxDeliveryTime = data.maxDeliveryTime;


          // const slotApiUrl = deliveryType === 'storePickup' ? this.apiFactory.getTimeSlotDetailsByUrlAndLocId : this.apiFactory.getTimeSlotDetailsByUrl;
          // const slotApiUrl = this.apiFactory.getTimeSlotDetailsByUrl;
          // const slotLocId = deliveryType === 'storePickup' ? locId : null;

          this.cartService.getTimeSlotList(this.apiFactory.getTimeSlotDetailsByUrl, this.currentUrl).subscribe((slotData) => {
            this.timeSlot2 = slotData.map((element) => [element.fromTime, element.toTime]);
            this.timeSlotAvl = this.timeSlot2.map(([fromTime, toTime]) => `${fromTime}-${toTime}`);

            var orderDuration = new Date();
            orderDuration.setHours(orderDuration.getHours() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[0]));
            orderDuration.setMinutes(orderDuration.getMinutes() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[1]));

            let maxOrderDuration = moment().add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[0]), "hours")
              .add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[1]), "minutes");

            // FETCH ALL STOCK DATA IN ONE CALL
            const productCodes = this.allProductList.map(p => p.product_Code);
            this.productService.getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, locId ?? 0, productCodes, this.currentUrl, deliveryType)
              .subscribe((stockList: WebOrderStockDetailsDto[]) => {

                this.allProductList.forEach((product) => {
                  const stockData = stockList.find(stock => stock.productCode === product.product_Code);
                  const minQty = product.minimum_Order_Quantity || 0;

                  let isAvailable = true; // Default to available

                  if (stockData) {
                    if (stockData.manualStockAllow) {
                      // Check manual stock only
                      if (stockData.manualStock < minQty) {
                        isAvailable = false;
                      } else {
                        isAvailable = true;
                      }
                    } else if (stockData.systemStockAllow) {
                      // Manual not allowed, check system stock
                      if (stockData.systemStock < minQty) {
                        isAvailable = false;
                      } else {
                        isAvailable = true;
                      }
                    }
                    // If neither manual/system allow: keep isAvailable = true
                  }

                  product.outOfStock = !isAvailable;     // For blur + out of stock UI
                  product.stockAvailable = isAvailable;  // For disabling Add to Cart

                  // DELIVERY DATE + TIMESLOT LOGIC (same as before)
                  let minOrderDate = new Date();
                  minOrderDate.setDate(minOrderDate.getDate() + product.minimum_Order_Time);

                  let greaterDate = orderDuration > minOrderDate ? orderDuration : minOrderDate;
                  let todayDate = moment(greaterDate);

                  product.deliveryDate = todayDate.format("YYYY-MM-DD");
                  product.defaultDate = todayDate.format("YYYY-MM-DD");
                  product.deliveryTime = todayDate.format("HH:mm");
                  product.maxDeliveryDate = maxOrderDuration.format("YYYY-MM-DD");
                  product.maxDeliveryTime = maxOrderDuration.format("HH:mm");

                  let totTime = todayDate.hours() * 60 + todayDate.minutes();
                  product.timeSlotAvl = [];
                  let matchedSlot = false;

                  for (const e of this.timeSlot2) {
                    let fromSlotTime = Number(e[0].split(":")[0]) * 60 + Number(e[0].split(":")[1]);
                    if (totTime < fromSlotTime) {
                      let tSlot = `${e[0]}-${e[1]}`;
                      product.timeSlotAvl.push(tSlot);
                      if (!matchedSlot) {
                        product.deliveryTime = tSlot;
                        matchedSlot = true;
                      }
                    }
                  }

                  if (!matchedSlot) {
                    todayDate = todayDate.clone().add(1, 'day');
                    product.deliveryDate = todayDate.format("YYYY-MM-DD");
                    product.timeSlotAvl = this.timeSlot2.map(slot => `${slot[0]}-${slot[1]}`);
                    product.deliveryTime = product.timeSlotAvl[0];
                  }

                  const today = moment().startOf('day');
                  const deliveryDay = todayDate.clone().startOf('day');

                  if (deliveryDay.isSame(today, 'day')) {
                    product.deliveryLabel = 'Today';
                  } else if (deliveryDay.diff(today, 'days') === 1) {
                    product.deliveryLabel = 'Tomorrow';
                  } else {
                    product.deliveryLabel = deliveryDay.format('Do MMM');
                  }
                });
                // console.log(this.productList);
                resolve();
              }, reject);
          }, reject);
        } else {
          reject("Invalid delivery data");
        }
      }, reject);
    });
  }

  setDelivery(product: Product) {
    let selfLife = JSON.parse(this.localStorage.getItem("min_selflife"));
    if (product.shelf_Life_In_Hours >= selfLife) {
      product.cartProductType = "Product";
      this.getProductWithStock(product);
    } else {
      this.toastrService.showErrorToast("Cannot add to cart, shelf life is under " + selfLife + " hours.");
    }
  }

  getProductWithStock(product: Product) {
    if (this.checkAllowStockSubscription) return;

    const locId = JSON.parse(this.localStorage.getItem('location_code'));

    if (!locId) {
      this.toastrService.showErrorToast("Location can't place order");
      return;
    }

    this.checkAllowStockSubscription = this.productService
      .getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, locId, [product.product_Code], this.currentUrl, 'delivery')
      .subscribe({
        next: (data: WebOrderStockDetailsDto[]) => {
          this.checkAllowStockSubscription = null;

          const stockData = data?.[0]; // Get the stock data for this single product
          if (!stockData) {
            this.toastrService.showErrorToast(`${product.product_Name} stock data not found.`);
            return;
          }

          const minQty = product.minimum_Order_Quantity || 0;

          // Check Manual Stock first
          if (stockData.manualStockAllow) {
            if (stockData.manualStock < minQty) {
              this.toastrService.showErrorToast(`${product.product_Name} is out of stock, available: ${stockData.manualStock}`);
              return;
            }
            this.getDesignBySubGroupAndUrl(product);
            return;
          }

          // Then check System Stock
          if (stockData.systemStockAllow) {
            if (stockData.systemStock < minQty) {
              this.toastrService.showErrorToast(`${product.product_Name} is out of stock, available: ${stockData.systemStock}`);
              return;
            }
            this.getDesignBySubGroupAndUrl(product);
            return;
          }

          // If neither manual nor system stock check is allowed, proceed anyway
          this.getDesignBySubGroupAndUrl(product);
        },
        error: (error: HttpErrorResponse) => {
          this.checkAllowStockSubscription = null;
          this.toastrService.showErrorToast('Something went wrong while checking stock.');
        }
      });
  }

  getDesignBySubGroupAndUrl(product: Product) {
    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem('avct_item')) || [];
    if (cartProducts.some((temp) => temp.product_Code == product.product_Code)) {
      this.toastrService.showErrorToast(product.product_Name + ' is already added to cart');
      return;
    }
    this.productService.addToCart1(product);
  }

  // get filteredItems(): MenuItem[] {
  //   return this.items.filter(item => {
  //     const matchesSearch = item.name.toLowerCase().includes(this.searchQuery.toLowerCase());
  //     const matchesFilter =
  //       this.filterType === 'all' ||
  //       (this.filterType === 'veg' && item.veg) ||
  //       (this.filterType === 'nonveg' && !item.veg);
  //     return matchesSearch && matchesFilter;
  //   });
  // }

  getCartQuantity(itemId: number): number {
    return this.cartService.getItemQuantity(itemId);
  }

  // addToCart(item: MenuItem) {
  //   if (this.restaurant) {
  //     this.cartService.addToCart(item, this.restaurant.id, this.restaurant.name);
  //   }
  // }

  addToCart1(item: Product) {
    if (this.restaurant) {
      this.cartService.addToCart(item, this.restaurant.id, this.restaurant.name);
    }
  }

  updateQuantity(itemId: number, quantity: number) {
    this.cartService.updateQuantity(itemId, quantity);
  }

  goBack() {
    this.router.navigate(['/']);
  }

  goToCart() {
    this.router.navigate(['/cart']);
  }

  // async openDeliveryTypeDialog(product: Product) {
  //   // let deliveryType = JSON.parse(this.localStorage.getItem('delivery_type'));
  //   let locId = JSON.parse(this.localStorage.getItem('location_code'));
  //   console.log('Location ID:', locId);
  //   if (!locId) {
  //     // const dialogRef = this.dialog.open(StorePickupDialogComponent, {
  //     //   width: '300px',
  //     //   autoFocus: false,
  //     //   panelClass: 'store-dialog-container'
  //     // });

  //     // dialogRef.afterClosed().subscribe(async result => {
  //     // console.log(result)
  //     // if (result) {
  //     await this.getProductDeliveryTimeAndStockDetails(); // wait for API to update productList
  //     const updatedProduct = this.productList.find(p => p.product_Code === product.product_Code);
  //     // if (result === 'storePickup') {
  //     //   this.setStorePickup(updatedProduct, goToCartPage);
  //     // } else if (result === 'delivery') {
  //     this.setDelivery(updatedProduct);
  //     // this.openPinDialog(product, goToCartPage);
  //   }
  //   // }
  //   // });
  //   // } else {
  //   //   if (deliveryType === 'storePickup') {
  //   //     this.setStorePickup(product, goToCartPage);
  //   // } else if (deliveryType === 'delivery') {
  //   this.setDelivery(product);
  //   // this.openPinDialog(product, goToCartPage);
  //   // }
  //   // }
  // }

  // setFilter(type: 'all' | 'veg' | 'nonveg') {
  //   this.filterType = type;

  //   if (type === 'all') {
  //     this.selectedSubGroup = null; // 👈 reset subgroup
  //   }
  // }

  // selectSubGroup(group: string) {
  //   this.selectedSubGroup = group;

  //   // 👇 Just ensure subgroup applies
  //   if (this.filterType === 'all') {
  //     this.filterType = null;
  //     // do nothing, filtering logic will handle it
  //   }
  // }

  setFilter(type: 'all' | 'veg' | 'nonveg') {
    // 👇 Toggle logic
    if (this.filterType === type) {
      this.filterType = null;   // deselect if clicked again
    } else {
      this.filterType = type;
    }

    // 👇 If "all" is selected, reset subgroup
    if (this.filterType === 'all') {
      this.selectedSubGroup = null;
    }
  }

  selectSubGroup(group: string) {
    // 👇 Toggle subgroup
    if (this.selectedSubGroup === group) {
      this.selectedSubGroup = null;  // deselect on second click
    } else {
      this.selectedSubGroup = group;
    }

    // 👇 Optional: reset filterType when subgroup selected
    if (this.selectedSubGroup) {
      this.filterType = null;
    }
  }

  get filteredItems(): Product[] {
    const search = (this.searchQuery || '').toLowerCase();

    return this.items.filter(item => {

      const matchesSearch =
        item.product_Name?.toLowerCase().includes(search);

      const matchesFilter =
        this.filterType === 'all' ||
        this.filterType === null ||   // 👈 important
        (this.filterType === 'veg' && item.food_Type === 'Veg') ||
        (this.filterType === 'nonveg' && item.food_Type === 'Non-Veg');

      const matchesSubGroup =
        !this.selectedSubGroup ||
        item.productSubGroup?.productSubGroupName === this.selectedSubGroup;

      return matchesSearch && matchesFilter && matchesSubGroup;
    });
  }
  // redirectToPartner(restaurantId: number, type: string) {
  //   console.log("restaurant id " + restaurantId, type)
  //   const restaurantData = this.aggregatorSetup?.[restaurantId];
  //   if (!restaurantData) {
  //     return;
  //   }
  //   // const partner = restaurantData.find(a =>
  //   //   a?.aggregatorType?.toUpperCase() === type.toUpperCase()
  //   // );
  //   const partner = restaurantData?.aggregatorRestaurantSetUp?.find(
  //     (a: any) =>
  //       a?.aggregatorType?.toUpperCase() === type.toUpperCase()
  //   );
  //   if (partner?.restaurantUrl) {
  //     window.open(partner.restaurantUrl, '_blank');
  //   } else {
  //     this.toastrService.showErrorToast("No aggregator found");
  //   }
  // }

  redirectToPartner(restaurantId: number, type: string) {
    if (!this.aggregatorSetup?.length) {
      this.toastrService.showErrorToast('No aggregator found');
      return;
    }

    const partner = this.aggregatorSetup.find(
      (item: any) =>
        item.restaurantRefNo === restaurantId &&
        item.aggregator?.toUpperCase() === type.toUpperCase()
    );

    if (partner?.restaurantUrl) {
      window.open(partner.restaurantUrl, '_blank');
    } else {
      this.toastrService.showErrorToast(`No ${type} link found`);
    }
  }

  selectedItem: any = null;

  openPrebookPopup(item: any) {
    this.selectedItem = item;
  }

  closePopup() {
    this.selectedItem = null;
  }

  isDesktop = window.innerWidth >= 768;

  @HostListener('window:resize', [])
  onResize() {
    this.isDesktop = window.innerWidth >= 768;
  }

  isSticky = false;
  @HostListener('window:scroll', [])
  onScroll() {
    const scrollY = window.scrollY;

    // when user scrolls past hero (400px)
    this.isSticky = scrollY > 200;
  }

}